<template>
  <div class="mt-4 px-4 container-fluid">
    <div class="breadcrumb text-md px-0 mb-4">
      <p><span class="breadcrumb-item" @click="irInicio">{{ $t('perfil.inicio') }}</span> > {{ $t('perfil.titulo') }}</p>
    </div>
  </div>

  <div class="px-4 container-fluid">
    <!-- Cabecera de perfil -->
    <div id="profile" class="card card-body mt-4 mb-4">
      <div v-if="profile" class="row justify-content-left align-items-left">
        <div class="col-sm-auto col-4">
          <soft-avatar :img="pic" alt="profile" size="xl" shadow="sm" border-radius="lg" />
        </div>
        <div class="col-sm-auto col-8 my-auto">
          <div class="h-100">
            <h5 class="mb-1 font-weight-bolder">{{ profile.name }}</h5>
            <p class="mb-0 font-weight-bold text-sm">{{ profile.email }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="row">

      <!-- ════════════════════ COLUMNA IZQUIERDA ════════════════════ -->
      <div class="col-12 col-sm-6">

        <!-- Información básica (solo usuarios NO tipster) -->
        <div id="basic-info" class="card mt-4 mb-4" v-if="!esTipster">
          <div class="card-header">
            <h5>{{ $t('perfil.infoBasicaTitulo') }}</h5>
          </div>
          <div class="card-body pt-0">
            <div class="row mb-3">
              <soft-field id="name" type="text" :useLabel="true" :label="$t('perfil.nombre')" name="name"
                v-model="profileChange.name" class="mb-2 label-input" largo="50"/>
              <validation-error :errors="apiValidationErrors.name" />
            </div>
            <div class="row mb-3">
              <soft-field id="email" type="text" :useLabel="true" :label="$t('perfil.email')" name="email"
                v-model="profileChange.email" class="mb-2 label-input" largo="100"/>
              <validation-error :errors="apiValidationErrors.email" />
            </div>
            <QBtn variant="tipster" :label="$t('perfil.actualizar')" style="min-width:150px;" class="float-end mt-3 mb-0"
              :loading="loading2" :disabled="loading2" @click="handleProfileChange" />
          </div>
        </div>

        <!-- Datos del tipster (solo tipsters) -->
        <div id="datos-tipster" class="card mt-4 mb-4" v-if="esTipster">
          <div class="card-header">
            <h5>{{ $t('perfil.datosTipsterTitulo') }}</h5>
          </div>
          <div class="card-body pt-0">
            <div class="row mb-3">
              <soft-field id="nombreTipster" type="text" :useLabel="true" :label="$t('perfil.nombre')" name="nombre"
                v-model="tipsterChange.nombre" class="mb-2 label-input" largo="50"/>
              <validation-error :errors="apiValidationErrors.nombre" />
            </div>
            <div class="row mb-3">
              <soft-field id="contactoTipster" type="text" :useLabel="true" :label="$t('perfil.contacto')" name="contacto"
                v-model="tipsterChange.contacto" class="mb-2 label-input" largo="80"/>
              <validation-error :errors="apiValidationErrors.contacto" />
            </div>
            <div class="row mb-3">
              <soft-field id="emailTipster" type="text" :useLabel="true" :label="$t('perfil.email')" name="email"
                v-model="tipsterChange.email" class="mb-2 label-input" largo="80"/>
              <validation-error :errors="apiValidationErrors.email" />
            </div>
            <div class="row mb-3" style="position:relative;">
              <div class="mb-0 mb-2 label-input4 completo">
                <label>{{ $t('perfil.telefono') }}</label>
                <vue-tel-input
                  v-model="tipsterChange.telefono"
                  :only-countries="['es','fr','pt','de','nl','ie','gb','mx','ar','cl','br']"
                  :valid-character-only="true"
                  :auto-format="true"
                  :autoDefaultCountry="false"
                  :placeholder="$t('perfil.telefonoPlaceholder')"
                  :inputoptions="{ showDialCode: true, placeholder: 'E164' }"
                  @blur="checkValidPhoneNumber"
                  @country-changed="handleCountryChange"
                />
              </div>
              <validation-error :errors="apiValidationErrors.telefono" />
            </div>
            <QBtn variant="tipster" :label="$t('perfil.guardarDatos')" style="min-width:180px;" class="float-end mt-3 mb-0"
              :loading="loading3" :disabled="loading3" @click="handleChangeTipster" />
          </div>
        </div>

        <!-- Cambio de clave (siempre) -->
        <div id="password" class="card mt-4">
          <div class="card-header">
            <h5>{{ $t('perfil.cambioClaveTitulo') }}</h5>
          </div>
          <div class="card-body pt-0">
            <div class="row mb-3">
              <soft-field id="newPassword" type="password" :useLabel="true" :label="$t('perfil.nuevaClave')" name="newPassword"
                v-model="passChange.password" class="mb-2 label-input" largo="100"/>
              <validation-error :errors="apiValidationErrors.password" />
            </div>
            <div class="row mb-3">
              <soft-field id="confirmPassword" type="password" :useLabel="true" :label="$t('perfil.confirmaNuevaClave')"
                name="confirmPassword" v-model="passChange.password_confirmation" class="mb-2 label-input" largo="100"/>
            </div>
            <QBtn variant="tipster" :label="$t('perfil.cambiarClave')" style="min-width:180px;" class="float-end mt-3 mb-0"
              :loading="loading" :disabled="loading" @click="handlePassChange" />
          </div>
        </div>

      </div>

      <!-- ════════════════════ COLUMNA DERECHA (solo tipsters) ════════════════════ -->
      <div class="col-12 col-sm-6" v-if="esTipster">
        <div id="stripe-tipster" class="card mt-4">
          <div class="card-header d-flex align-items-center justify-content-between">
            <h5 class="mb-0">{{ $t('perfil.stripeTitulo') }}</h5>
            <button class="btn-ayuda-stripe" @click="showStripeHelp = !showStripeHelp" title="Ayuda">?</button>
          </div>

          <!-- Panel de ayuda -->
          <div class="stripe-ayuda" v-if="showStripeHelp">
            <div class="stripe-ayuda-body">
              <p class="stripe-ayuda-titulo">{{ $t('perfil.stripeAyudaTitulo') }}</p>
              <dl>
                <dt>Clave pública <code>pk_live_…</code></dt>
                <dd>Identifica tu cuenta Stripe en el navegador del cliente. Es seguro compartirla — no permite cobros sin la clave secreta.</dd>
                <dt>Clave secreta <code>sk_live_…</code></dt>
                <dd>Se usa en el servidor para procesar los cobros. <strong>Nunca la compartas</strong> ni la pongas en código público.</dd>
              </dl>
              <p class="stripe-ayuda-titulo mt-2">¿Cómo obtenerlas?</p>
              <ol>
                <li>Inicia sesión en <strong>dashboard.stripe.com</strong></li>
                <li>Ve a <strong>Desarrolladores → Claves de API</strong></li>
                <li>Copia la <em>Clave publicable</em> (pk_live_…) y la <em>Clave secreta</em> (sk_live_…)</li>
                <li>Pégalas aquí y pulsa <strong>Guardar Stripe</strong></li>
              </ol>
              <p class="text-xs text-muted mb-0">
                ⚠️ Usa claves de <strong>live</strong> (producción) para cobros reales, o <strong>test</strong> para pruebas.
              </p>
            </div>
          </div>

          <div class="card-body pt-2">

            <!-- Paso 1: Claves de acceso -->
            <div class="row mb-3">
              <div class="mb-2 label-input">
                <label>{{ $t('perfil.clavePublica') }}</label>
                <div class="stripe-secret-wrapper">
                  <input
                    type="text"
                    class="form-control-stripe"
                    v-model="stripeChange.stripe_public_key"
                    placeholder="pk_live_... (vacío = no cambiar)"
                    maxlength="120"
                  />
                  <span v-if="stripeChange.stripe_public_key_set && !stripeChange.stripe_public_key"
                    class="badge-configurada">
                    {{ $t('perfil.configurada') }}
                  </span>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="mb-2 label-input">
                <label>{{ $t('perfil.claveSecreta') }}</label>
                <div class="stripe-secret-wrapper">
                  <input
                    type="password"
                    class="form-control-stripe"
                    v-model="stripeChange.stripe_secret_key"
                    placeholder="sk_live_... (vacío = no cambiar)"
                    maxlength="200"
                    autocomplete="new-password"
                  />
                  <span v-if="stripeChange.stripe_secret_key_set && !stripeChange.stripe_secret_key"
                    class="badge-configurada">
                    {{ $t('perfil.configurada') }}
                  </span>
                </div>
              </div>
            </div>

            <!-- Botón generar URL (solo si no tiene UUID) -->
            <div v-if="!stripeChange.stripe_webhook_uuid" class="mb-4">
              <QBtn
                variant="tipster"
                :label="$t('perfil.generarUrl')"
                style="min-width:210px;"
                class="mb-2"
                :loading="loadingGenerar"
                :disabled="loadingGenerar || (!stripeChange.stripe_public_key && !stripeChange.stripe_secret_key && !stripeChange.stripe_secret_key_set)"
                @click="handleGenerarUrl"
              />
              <p class="text-xs text-muted mb-0 mt-1">
                {{ $t('perfil.guardarParaUrl') }}
              </p>
            </div>

            <!-- Paso 2: Sección webhook (visible solo cuando existe UUID) -->
            <template v-if="stripeChange.stripe_webhook_uuid">

              <div class="webhook-step-divider mb-3">
                <span>Webhook</span>
              </div>

              <!-- Guía webhook -->
              <div class="webhook-guide mb-3">
                <div class="webhook-guide-header" @click="showWebhookHelp = !showWebhookHelp">
                  <span>{{ $t('perfil.webhookGuiaTitulo') }}</span>
                  <span class="webhook-chevron">{{ showWebhookHelp ? '▲' : '▼' }}</span>
                </div>
                <div v-if="showWebhookHelp" class="webhook-guide-body">
                  <p class="mb-2">
                    Si ofreces <strong>suscripciones mensuales</strong>, necesitas registrar un webhook en Stripe
                    para que Quanty reciba los eventos de cobro, fallo y cancelación automáticamente.
                  </p>
                  <ol class="webhook-steps">
                    <li>
                      Accede a tu panel de Stripe:
                      <a href="https://dashboard.stripe.com/webhooks" target="_blank" rel="noopener">dashboard.stripe.com/webhooks</a>
                    </li>
                    <li>Haz clic en <strong>"Añadir endpoint"</strong>.</li>
                    <li>
                      En <strong>"URL del endpoint"</strong> pega esta dirección:
                      <div class="webhook-url-box">
                        <code>{{ webhookUrl }}</code>
                        <button type="button" class="btn-copy-webhook" @click.prevent="copiarWebhookUrl">
                          {{ copiado ? $t('perfil.copiado') : $t('perfil.copiar') }}
                        </button>
                      </div>
                    </li>
                    <li>
                      En <strong>"Seleccionar eventos"</strong> activa estos siete:
                      <ul class="webhook-events">
                        <li><code>customer.subscription.deleted</code> — marca la suscripción como cancelada</li>
                        <li><code>invoice.paid</code> — renueva la suscripción cada mes</li>
                        <li><code>invoice.payment_failed</code> — activa el periodo de gracia si falla el cobro</li>
                        <li><code>payment_intent.succeeded</code> — confirma el primer pago</li>
                        <li><code>payment_intent.payment_failed</code> — registra el fallo del primer pago</li>
                        <li><code>charge.refunded</code> — registra devoluciones realizadas desde Stripe</li>
                        <li><code>charge.dispute.created</code> — alerta cuando se abre un contracargo (chargeback)</li>
                      </ul>
                    </li>
                    <li>Haz clic en <strong>"Crear destino"</strong>. Stripe mostrará un <strong>Signing Secret</strong> (<code>whsec_...</code>) — revélalo y cópialo.</li>
                    <li>Pega ese Signing Secret en el campo <strong>"Webhook Secret"</strong> de abajo y pulsa <strong>Guardar Stripe</strong>.</li>
                  </ol>
                  <div class="webhook-tip">
                    💡 Si usas claves de <strong>test</strong> (<code>pk_test_...</code>), crea el webhook también en modo test. Al pasar a <strong>live</strong>, repite el proceso con las claves reales — el webhook secret cambia entre entornos.
                  </div>
                </div>
              </div>

              <!-- Guía Apple Pay -->
              <div class="webhook-guide mb-3">
                <div class="webhook-guide-header" @click="showApplePayHelp = !showApplePayHelp">
                  <span>{{ $t('perfil.applePayGuiaTitulo') }}</span>
                  <span class="webhook-chevron">{{ showApplePayHelp ? '▲' : '▼' }}</span>
                </div>
                <div v-if="showApplePayHelp" class="webhook-guide-body">
                  <p class="mb-2">
                    Para que tus compradores puedan pagar con <strong>Apple Pay</strong> desde Safari o iPhone,
                    debes registrar el dominio de la plataforma en tu cuenta de Stripe.
                  </p>
                  <ol class="webhook-steps">
                    <li>
                      Accede a tu panel de Stripe:
                      <a href="https://dashboard.stripe.com/settings/payment_method_domains" target="_blank" rel="noopener">
                        Settings → Payment methods → Apple Pay
                      </a>
                    </li>
                    <li>Haz clic en <strong>"Add domain"</strong>.</li>
                    <li>
                      Introduce exactamente este dominio:
                      <div class="webhook-url-box">
                        <code>quanty.payoned.com</code>
                        <button type="button" class="btn-copy-webhook" @click.prevent="copiarDominioPay">
                          {{ copiadoDominio ? $t('perfil.copiado') : $t('perfil.copiar') }}
                        </button>
                      </div>
                    </li>
                    <li>Stripe verificará automáticamente el dominio. Cuando aparezca <strong>"Verified"</strong>, Apple Pay estará activo para tus clientes.</li>
                  </ol>
                  <div class="webhook-tip">
                    💡 Si usas claves de <strong>test</strong>, repite este paso en modo test. Cada entorno (test / live) tiene su propia lista de dominios verificados.
                  </div>
                </div>
              </div>

              <!-- Webhook Secret -->
              <div class="row mb-3">
                <div class="mb-2 label-input">
                  <label>{{ $t('perfil.webhookSecret') }}</label>
                  <div class="stripe-secret-wrapper">
                    <input
                      type="password"
                      class="form-control-stripe"
                      v-model="stripeChange.stripe_webhook_secret"
                      :placeholder="stripeChange.stripe_webhook_secret_set ? 'whsec_... (vacío = no cambiar)' : 'whsec_...'"
                      maxlength="200"
                      autocomplete="new-password"
                    />
                    <span v-if="stripeChange.stripe_webhook_secret_set && !stripeChange.stripe_webhook_secret"
                      class="badge-configurada">
                      {{ $t('perfil.configurado') }}
                    </span>
                  </div>
                </div>
              </div>

              <!-- Periodo de gracia para suscripciones -->
              <div class="gracia-row mb-3">
                <span class="gracia-badge">{{ $t('perfil.suscripciones') }}</span>
                <label class="gracia-label">{{ $t('perfil.graciaPagosFallidos') }}</label>
                <input
                  type="number"
                  class="form-control gracia-input"
                  v-model.number="stripeChange.horas_gracia_pago"
                  min="1"
                  max="720"
                  step="1"
                />
                <span class="gracia-unidad">h</span>
                <button class="btn-ayuda-stripe" @click="showGraciaHelp = !showGraciaHelp" title="Ayuda suscripciones">?</button>
              </div>
              <div class="stripe-ayuda mb-3" v-if="showGraciaHelp">
                <div class="stripe-ayuda-body">
                  <p class="stripe-ayuda-titulo">{{ $t('perfil.graciaAyudaTitulo') }}</p>
                  <p class="mb-1">Cuando un cobro mensual falla, el suscriptor recibe un aviso por email y tiene este tiempo para regularizar su tarjeta.</p>
                  <p class="mb-1">Pasado el plazo, el sistema reintenta el cobro automáticamente. Si vuelve a fallar, el suscriptor es <strong>expulsado del canal</strong> (sin baneo — puede volver si paga).</p>
                  <p class="mb-0 text-muted"><strong>Por defecto: 48 h.</strong> Máximo: 720 h (30 días).</p>
                </div>
              </div>

              <!-- Resultado de la prueba -->
              <div v-if="stripeTestResult" :class="['stripe-test-result', stripeTestResult.ok ? 'ok' : 'error']">
                {{ stripeTestResult.mensaje }}
              </div>

              <!-- Botones de acción -->
              <div class="stripe-acciones">
                <button
                  class="btn btn-outline-secondary btn-sm"
                  :disabled="!stripeChange.stripe_secret_key_set || testingStripe"
                  @click="handleTestStripe"
                >
                  <span v-if="testingStripe" class="spinner-border spinner-border-sm me-1"></span>
                  <span v-else>{{ $t('perfil.probarConexion') }}</span>
                </button>

                <QBtn variant="tipster" :label="$t('perfil.guardarStripe')" style="min-width:160px;" class="mb-0"
                  :loading="loadingStripe" :disabled="loadingStripe" @click="handleStripeChange" />
              </div>

              <p v-if="stripeChange.stripe_public_key || stripeChange.stripe_secret_key_set"
                class="text-xs text-muted mt-3 mb-0">
                {{ $t('perfil.eliminarIntegracion') }}
              </p>

            </template>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import SoftAvatar from "@/components/SoftAvatar.vue";
import SoftField from "@/components/SoftField.vue";
import ValidationError from "@/components/ValidationError.vue";
import formMixin from "/src/mixins/form-mixin.js";
import img from "/src/assets/img/bruce-mars.jpg";
import showSwal from "/src/mixins/showSwal.js";
import { isValidPhoneNumber } from 'libphonenumber-js';

export default {
  name: "Profile",
  components: { SoftAvatar, SoftField, ValidationError },
  mixins: [formMixin],
  data() {
    return {
      telInputReady: false,
      passChange:    { password: "", password_confirmation: "" },
      profileChange: { name: "", email: "", profile_image: "" },
      tipsterChange: { id: 0, nombre: "", contacto: "", email: "", telefono: "" },
      stripeChange:     { stripe_public_key: "", stripe_public_key_set: false, stripe_secret_key: "", stripe_secret_key_set: false, stripe_webhook_secret: "", stripe_webhook_secret_set: false, stripe_webhook_uuid: null, horas_gracia_pago: 48 },
      loading:          false,
      loading2:         false,
      loading3:         false,
      loadingStripe:    false,
      loadingGenerar:   false,
      testingStripe:    false,
      showStripeHelp:   false,
      showGraciaHelp:   false,
      showWebhookHelp:  true,
      showApplePayHelp: false,
      copiado:          false,
      copiadoDominio:   false,
      stripeTestResult: null,
      img,
      isValidPhoneNumber: true,
    };
  },
  computed: {
    webhookUrl() {
      const base = (process.env.VUE_APP_API_BASE_URL || '').replace(/\/$/, '');
      const uuid = this.stripeChange.stripe_webhook_uuid;
      return uuid ? `${base}/api/v2/stripe/webhook/${uuid}` : `${base}/api/v2/stripe/webhook`;
    },
    profile() {
      return this.$store.getters["profile/profile"];
    },
    pic() {
      if (this.profile?.profile_image) return this.profile.profile_image;
      return require("/src/assets/img/placeholder.jpg");
    },
    esTipster() {
      if (!this.profile) return false;
      const rol = Number(this.profile.rol_efectivo || this.profile.rol_id || 0);
      return rol === 2 || rol === 4;
    },
  },
  async created() {
    try {
      await this.$store.dispatch("profile/getProfile");
      this.profileChange = {
        name:          this.profile.name,
        email:         this.profile.email,
        profile_image: this.profile.profile_image,
      };
      if (this.profile.tipster) {
        this.tipsterChange = { ...this.profile.tipster };
        this.$nextTick(() => { this.telInputReady = true; });
        this.stripeChange.stripe_public_key          = '';
        this.stripeChange.stripe_public_key_set      = !!this.profile.tipster.stripe_public_key_set;
        this.stripeChange.stripe_secret_key          = '';
        this.stripeChange.stripe_secret_key_set      = !!this.profile.tipster.stripe_secret_key_set;
        this.stripeChange.stripe_webhook_secret      = '';
        this.stripeChange.stripe_webhook_secret_set  = !!this.profile.tipster.stripe_webhook_secret_set;
        this.stripeChange.stripe_webhook_uuid        = this.profile.tipster.stripe_webhook_uuid || null;
        this.stripeChange.horas_gracia_pago          = this.profile.tipster.horas_gracia_pago != null
          ? Number(this.profile.tipster.horas_gracia_pago)
          : 48;
      }
    } catch (error) {
      try {
        await this.$store.dispatch("auth/logout");
      } finally {
        this.$router.push("/login");
      }
    }
  },
  methods: {
    irInicio() {
      this.$router.push('/dashboard');
    },

    async handlePassChange() {
      this.resetApiValidation();
      this.loading = true;
      try {
        await this.$store.dispatch("profile/updateProfile", this.passChange);
        showSwal.methods.showSwal({ type: "success", message: this.$t('perfil.clavesCambiadas'), width: 500 });
        this.passChange.password = "";
        this.passChange.password_confirmation = "";
      } catch (error) {
        this.setApiValidation(error?.response?.data?.errors);
      } finally {
        this.loading = false;
      }
    },

    async handleProfileChange() {
      this.resetApiValidation();
      this.loading2 = true;
      try {
        await this.$store.dispatch("profile/updateProfile", this.profileChange);
        showSwal.methods.showSwal({ type: "success", message: this.$t('perfil.infoActualizada'), width: 500 });
      } catch (error) {
        this.setApiValidation(error?.response?.data?.errors);
      } finally {
        this.loading2 = false;
      }
    },

    async handleChangeTipster() {
      if (!this.isValidPhoneNumber) {
        showSwal.methods.showSwal({ type: "error", message: this.$t('perfil.telefonoErroneo'), width: 500 });
        return;
      }
      this.resetApiValidation();
      this.loading3 = true;
      try {
        const resp = await this.$store.dispatch("profile/updateTipster", this.tipsterChange);
        showSwal.methods.showSwal({
          type:    resp.res === 'OK' ? "success" : "error",
          message: resp.res === 'OK' ? this.$t('perfil.datosGuardados') : (resp.error || 'Error'),
          width:   600,
        });
      } catch (error) {
        showSwal.methods.showSwal({ type: "error", message: this.$t('perfil.errorConexion'), width: 500 });
      } finally {
        this.loading3 = false;
      }
    },

    checkValidPhoneNumber() {
      this.isValidPhoneNumber = isValidPhoneNumber(this.tipsterChange.telefono || '');
    },

    async copiarWebhookUrl() {
      try {
        await navigator.clipboard.writeText(this.webhookUrl);
        this.copiado = true;
        setTimeout(() => { this.copiado = false; }, 2000);
      } catch { /* fallback silencioso */ }
    },

    async copiarDominioPay() {
      try {
        await navigator.clipboard.writeText('quanty.payoned.com');
        this.copiadoDominio = true;
        setTimeout(() => { this.copiadoDominio = false; }, 2000);
      } catch { /* fallback silencioso */ }
    },

    handleCountryChange(countryData) {
      if (!this.telInputReady) return;
      const prefijo = '+' + countryData.dialCode;
      const phone = (this.tipsterChange.telefono || '').replace(/\s/g, '');
      // Solo actualizar si el campo está vacío o solo contiene un prefijo (sin número local)
      if (!phone || /^\+\d{0,4}$/.test(phone)) {
        this.tipsterChange.telefono = prefijo;
      }
    },

    async handleGenerarUrl() {
      this.loadingGenerar = true;
      try {
        const resp = await this.$store.dispatch("profile/updateTipsterStripe", {
          stripe_public_key:     this.stripeChange.stripe_public_key,
          stripe_secret_key:     this.stripeChange.stripe_secret_key,
          stripe_webhook_secret: '',
          horas_gracia_pago:     this.stripeChange.horas_gracia_pago,
        });
        if (resp?.res === 'OK') {
          this.stripeChange.stripe_public_key_set = !!resp.stripe_public_key;
          this.stripeChange.stripe_public_key     = '';
          this.stripeChange.stripe_secret_key     = '';
          this.stripeChange.stripe_secret_key_set = !!resp.stripe_secret_key_set;
          this.stripeChange.stripe_webhook_uuid   = resp.stripe_webhook_uuid || null;
          showSwal.methods.showSwal({ type: 'success', message: this.$t('perfil.urlGenerada'), width: 560 });
        } else {
          showSwal.methods.showSwal({ type: 'error', message: resp?.mensaje || this.$t('perfil.errorGuardarClaves'), width: 500 });
        }
      } catch {
        showSwal.methods.showSwal({ type: 'error', message: this.$t('perfil.errorConexion'), width: 500 });
      } finally {
        this.loadingGenerar = false;
      }
    },

    async handleStripeChange() {
      this.loadingStripe    = true;
      this.stripeTestResult = null;
      try {
        // Advertir si cambia clave pública/secreta con suscripciones activas
        const cambiandoClaves = this.stripeChange.stripe_secret_key || this.stripeChange.stripe_public_key !== (this.profile?.tipster?.stripe_public_key || '');
        if (cambiandoClaves) {
          try {
            const check = await this.$store.dispatch("profile/suscripcionesActivas");
            if ((check?.total ?? 0) > 0) {
              const { isConfirmed } = await showSwal.methods.showConfirm({
                title: this.$t('perfil.suscripcionesActivasTitulo'),
                message: this.$t('perfil.suscripcionesActivasMsg', { total: check.total }),
                type: 'warning',
                confirmButtonText: this.$t('perfil.siCambiar'),
                cancelButtonText: this.$t('perfil.cancelar'),
                width: 560,
              });
              if (!isConfirmed) {
                this.loadingStripe = false;
                return;
              }
            }
          } catch { /* si falla la comprobación, dejamos pasar */ }
        }

        const resp = await this.$store.dispatch("profile/updateTipsterStripe", {
          stripe_public_key:    this.stripeChange.stripe_public_key,
          stripe_secret_key:    this.stripeChange.stripe_secret_key,
          stripe_webhook_secret: this.stripeChange.stripe_webhook_secret,
          horas_gracia_pago:    this.stripeChange.horas_gracia_pago,
        });
        if (resp?.res === 'OK') {
          this.stripeChange.stripe_public_key_set     = !!resp.stripe_public_key;
          this.stripeChange.stripe_public_key         = '';
          this.stripeChange.stripe_secret_key         = '';
          this.stripeChange.stripe_secret_key_set     = !!resp.stripe_secret_key_set;
          this.stripeChange.stripe_webhook_secret     = '';
          this.stripeChange.stripe_webhook_secret_set = !!resp.stripe_webhook_secret_set;
          this.stripeChange.stripe_webhook_uuid       = resp.stripe_webhook_uuid || null;
          if (resp.horas_gracia_pago != null) this.stripeChange.horas_gracia_pago = Number(resp.horas_gracia_pago);
          showSwal.methods.showSwal({ type: 'success', message: this.$t('perfil.stripeGuardado'), width: 500 });
        } else {
          showSwal.methods.showSwal({ type: 'error', message: resp?.mensaje || this.$t('perfil.errorGuardar'), width: 500 });
        }
      } catch (e) {
        showSwal.methods.showSwal({ type: 'error', message: this.$t('perfil.errorConexion'), width: 500 });
      } finally {
        this.loadingStripe = false;
      }
    },

    async handleTestStripe() {
      this.testingStripe    = true;
      this.stripeTestResult = null;
      try {
        const resp = await this.$store.dispatch("profile/testStripe");
        this.stripeTestResult = {
          ok:      resp?.res === 'OK',
          mensaje: resp?.mensaje || (resp?.res === 'OK' ? this.$t('perfil.conexionCorrecta') : this.$t('perfil.errorDesconocido')),
        };
      } catch (e) {
        this.stripeTestResult = { ok: false, mensaje: this.$t('perfil.errorConexionServidor') };
      } finally {
        this.testingStripe = false;
      }
    },
  },
};
</script>

<style>
img { object-fit: cover; }
/* Stripe: botón de ayuda */
.btn-ayuda-stripe {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: 2px solid var(--q-gold);
  background: transparent;
  color: var(--q-gold);
  font-size: 0.85rem;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.18s;
}
.btn-ayuda-stripe:hover {
  background: var(--q-gold);
  color: var(--q-gold-on);
}

/* Panel de ayuda */
.stripe-ayuda {
  background: var(--q-hover);
  border-top: 1px solid var(--q-border);
  border-bottom: 1px solid var(--q-border);
  padding: 0;
}
.stripe-ayuda-body {
  padding: 14px 20px;
  font-size: 0.82rem;
  color: var(--q-text);
  line-height: 1.5;
}
.stripe-ayuda-titulo {
  font-weight: 700;
  color: var(--q-text);
  margin-bottom: 6px;
}
.stripe-ayuda dt {
  font-weight: 600;
  color: var(--q-gold);
  margin-top: 6px;
}
.stripe-ayuda dd {
  margin-left: 12px;
  margin-bottom: 4px;
}
.stripe-ayuda ol {
  padding-left: 18px;
  margin-bottom: 0;
}
.stripe-ayuda li { margin-bottom: 3px; }
.stripe-ayuda code {
  font-size: 0.78rem;
  background: var(--q-hover);
  padding: 1px 4px;
  border-radius: 3px;
}

/* Resultado de prueba */
.stripe-test-result {
  font-size: 0.82rem;
  font-weight: 600;
  padding: 8px 12px;
  border-radius: 6px;
  margin-bottom: 10px;
}
.stripe-test-result.ok    { background: var(--q-green-soft); color: var(--q-green); }
.stripe-test-result.error { background: var(--q-red-soft); color: var(--q-red); }

/* Fila de botones Stripe */
.stripe-acciones {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 16px;
  flex-wrap: wrap;
}

@media (max-width: 480px) {
  .stripe-acciones {
    flex-direction: column;
    align-items: stretch;
  }
  .stripe-acciones .btn,
  .stripe-acciones button {
    width: 100%;
    text-align: center;
    justify-content: center;
  }
}

/* Stripe card */
.stripe-secret-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
}
.form-control-stripe {
  flex: 1;
  min-width: 0;
  padding: 0.2rem 0.75rem;
  border-radius: 0;
  border-top: 0;
  border-left: 0;
  border-right: 0;
  background-color: var(--q-hover) !important;
  font-size: 0.875rem;
  color: var(--q-text) !important;
  outline: none;
  border-bottom: 1px solid var(--q-border);
}
.form-control-stripe::placeholder { color: var(--q-muted) !important; }
.form-control-stripe:focus {
  border-bottom-color: var(--q-gold);
  background-color: var(--q-hover) !important;
}
.badge-configurada {
  white-space: nowrap;
  flex-shrink: 0;
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--q-green);
  background: var(--q-green-soft);
  border-radius: 10px;
  padding: 2px 8px;
}

@media (max-width: 480px) {
  .stripe-ayuda-body { padding: 12px 14px; }
}

/* Periodo de gracia — fila compacta en una línea */
.gracia-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
}
@media (max-width: 480px) {
  .gracia-row { flex-wrap: wrap; }
}
.gracia-badge {
  font-size: 0.68rem;
  font-weight: 600;
  color: var(--q-gold);
  background: var(--q-amber-soft);
  border-radius: 10px;
  padding: 2px 8px;
  white-space: nowrap;
  flex-shrink: 0;
}
.gracia-label {
  font-size: 0.82rem;
  color: var(--q-text);
  white-space: nowrap;
  flex-shrink: 0;
  margin: 0;
}
.gracia-input {
  width: 72px !important;
  min-width: 0;
  text-align: center;
  padding: 0.25rem 0.4rem !important;
  font-size: 0.875rem !important;
  flex-shrink: 0;
}
.gracia-unidad {
  font-size: 0.82rem;
  color: var(--q-muted);
  white-space: nowrap;
  flex-shrink: 0;
}

/* Webhook guide */
.webhook-step-divider {
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--q-text-muted, #888);
  font-size: 0.78rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.webhook-step-divider::before,
.webhook-step-divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background: var(--q-border, #333);
}
.webhook-guide {
  border: 1px solid var(--q-border);
  border-radius: 10px;
  overflow: hidden;
}
.webhook-guide-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 9px 14px;
  background: var(--q-hover);
  cursor: pointer;
  font-weight: 600;
  font-size: 0.82rem;
  color: var(--q-gold);
  user-select: none;
}
.webhook-guide-header:hover { background: var(--q-hover); }
.webhook-chevron { font-size: 0.72rem; opacity: 0.7; }
.webhook-guide-body {
  padding: 14px 16px 12px;
  font-size: 0.81rem;
  color: var(--q-text);
  line-height: 1.55;
}
.webhook-steps { padding-left: 18px; margin-bottom: 10px; }
.webhook-steps li { margin-bottom: 9px; }
.webhook-steps a { color: var(--q-gold); word-break: break-all; }
.webhook-url-box {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 5px;
  background: var(--q-card-alt);
  border: 1px solid var(--q-border);
  border-radius: 6px;
  padding: 6px 10px;
  flex-wrap: wrap;
}
.webhook-url-box code { font-size: 0.78rem; color: var(--q-red); word-break: break-all; flex: 1; }
.btn-copy-webhook {
  flex-shrink: 0;
  padding: 3px 10px;
  border: 1px solid var(--q-gold);
  border-radius: 6px;
  background: var(--q-card);
  color: var(--q-gold);
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
}
.btn-copy-webhook:hover { background: var(--q-hover); }
.webhook-events { margin-top: 7px; padding-left: 16px; }
.webhook-events li { margin-bottom: 5px; }
.webhook-events code { background: var(--q-hover); padding: 1px 5px; border-radius: 4px; font-size: 0.77rem; color: var(--q-red); }
.webhook-tip {
  background: var(--q-amber-soft);
  border-left: 3px solid var(--q-amber);
  padding: 7px 11px;
  border-radius: 4px;
  font-size: 0.78rem;
  color: var(--q-text);
  margin-top: 4px;
}
</style>
